import { type ReactNode } from 'react';
import { Button } from '../../Button/Button';
import { DialogButtonsConfig } from '../types';
import {
    DialogWithDoubleEscape,
    useDialogClose,
} from './DialogWithDoubleEscape';
import { Icon } from '../../Icon/Icon';

export function ConfirmDialog({
    title,
    children,
    onClose,
    buttons,
    loading,
    onSubmit,
}: {
    title?: ReactNode;
    children: ReactNode;
    buttons?: DialogButtonsConfig;
    onClose: () => void;
    loading: boolean;
    onSubmit?: () => void;
}): ReactNode {
    function ButtonsContent(): ReactNode {
        const close = useDialogClose();
        const buttonsTemplate = (
            <>
                <Button label="Cancel" severity="secondary" onClick={close} />
                <Button
                    label={buttons?.submitLabel ?? 'Confirm'}
                    loading={loading}
                    onClick={() => {
                        onSubmit?.();
                    }}
                />
            </>
        );

        return (
            <div className="flex flex-row justify-content-center mt-5">
                <div className="flex flex-row gap-2">
                    {buttons?.content ?? null}
                    {!buttons?.content && buttonsTemplate}
                </div>
            </div>
        );
    }

    function HeaderContent(): ReactNode {
        const close = useDialogClose();
        return (
            <div className="flex flex-row justify-content-between">
                <div className="flex align-items-center">{title}</div>
                <Button
                    icon={<Icon name="cancel" fontSize="normal" />}
                    rounded
                    text
                    onClick={close}
                />
            </div>
        );
    }

    return (
        <DialogWithDoubleEscape
            onClose={onClose}
            className="dialog-confirm"
            header={<HeaderContent />}
        >
            {children}
            <ButtonsContent />
        </DialogWithDoubleEscape>
    );
}
